import { FunctionComponent } from "react";

import { classNames } from "@/utils/classNames";

import { StepSegmentState } from "./outbox-card-status.helper";

const SEGMENT_CLASSES: Record<StepSegmentState, string> = {
	done: "bg-status-success",
	current: "bg-brand-light",
	error: "bg-status-error",
	paused: "bg-status-warning",
	wait: "bg-gray-300",
};

interface StepProgressBarProps {
	segments: StepSegmentState[];
	label: string;
}

/** The sequence progress strip on a compact lead card: one segment per send step. */
export const StepProgressBar: FunctionComponent<StepProgressBarProps> = ({ segments, label }) => (
	<div className="flex items-center gap-2 mt-1">
		<div className="flex gap-[3px] flex-1" data-testid="step-progress-segments">
			{segments.map((state, index) => (
				<span
					key={index}
					className={classNames("h-1 rounded-sm flex-1", SEGMENT_CLASSES[state])}
					data-segment={state}
				/>
			))}
		</div>
		<span className="text-xs font-semibold text-text-meta whitespace-nowrap">{label}</span>
	</div>
);
